if (typeof grecaptcha !== 'undefined' && window.recaptchaSiteKey) {
    grecaptcha.ready(function() {
        grecaptcha.execute(window.recaptchaSiteKey, {action: 'signup'}).then(function(token) {
            var field = document.getElementById('recaptcha');
            if (token && field) {
                field.value = token;
            }
        });
    });
}
